import { displayToast } from '@/components/ui/toast/displayToast'
import { 
   ErrorResponse } from '../types/serviceTypes'
import { getErrorResponse } from './errorCodes'

const displayBadStatus = (status: number) => {
  const message = getErrorResponse(status)
  displayToast('error', 'Błąd', message)
  return message
}

/**
 * Displays an error message based on the API response status.
 * If the response status is 400, it calls the `displayBadRequest` function.
 * If the response status is neither 400 nor 401, it calls the `displayBadStatus` function.
 *
 * @param {APIResponse} response - The API response object.
 */
const displayError = (response: ErrorResponse) => {
    if(response.data.message){
      displayToast('error', 'Błąd', response.data.message)
      return
    }
    return displayBadStatus(response.status)
}

export default displayError
